import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ComputPage from '@/components/ComputePage.vue';
import ComputeWizardSurface from '@/components/ComputeWizard/ComputeWizardSurface.vue';
import { RoutePath } from '@/enums/Router';
import { useSizeStepStore } from '@/store/sizeStep';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComputeSurfacePage',
  setup(__props) {

const { t } = useI18n();
const sizeStepStore = useSizeStepStore();

const title = computed(() => {
  return sizeStepStore.selectedObject
    ? t('home.steps.surface.label_with_size_value', { size_value: sizeStepStore.selectedObject.key })
    : t('home.steps.surface.label');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ComputPage, {
    class: "compute-surface-page",
    "prev-url": _unref(RoutePath).COMPUTE_STEP_SIZE,
    "next-url": _unref(RoutePath).COMPUTE_STEP_FRICTION,
    title: title.value,
    subtitle: _ctx.$t('home.steps.surface_subtitle.label'),
    "current-step": 2
  }, {
    default: _withCtx(() => [
      _createVNode(ComputeWizardSurface)
    ]),
    _: 1
  }, 8, ["prev-url", "next-url", "title", "subtitle"]))
}
}

})